export const firebaseConfig = {
    apiKey: "AIzaSyDpYI3WQINIGTJIGF_EwgFfkjo9aiH06eQ",
    authDomain: "otherlet-com.firebaseapp.com",
    projectId: "otherlet-com",
    storageBucket: "otherlet-com.appspot.com",
    messagingSenderId: "576981659305",
    appId: "1:576981659305:web:6bfa26686ccc8fa14e43b8",
    measurementId: "G-Q6872LR3D9"
};
